import { Select, SelectOption } from 'ui';
import useQueryApiClient from 'utils/useQueryApiClient';
import { Validations } from 'interfaces';
import { useEffect, useState } from 'react';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';

interface EnumProps {
  id: number;
  name: string;
}

interface GeneralSelectProps extends Validations {
  name?: (string | number)[] | string | number;
  label?: string;
  url: string;
  reload?: number;
}

const GeneralSelect = ({ name, label, url, reload }: GeneralSelectProps) => {
  const [fetched, setFetched] = useState([]);

  const form = useFormInstance();

  const { refetch } = useQueryApiClient({
    request: {
      url: url,
    },
    onSuccess: (response) => {
      form.resetFields([name]);
      setFetched(response);
    },
  });

  useEffect(() => {
    if (url) {
      refetch();
    }
  }, [reload, url]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Select label={label} name={name}>
      {fetched.map((entry: EnumProps) => (
        <SelectOption key={entry.id} value={entry.id}>
          {entry.name}
        </SelectOption>
      ))}
    </Select>
  );
};

export default GeneralSelect;
